module.exports = __webpack_public_path__ + "static/media/IMG_20191204_130843.9c77cbad.jpg";